<!-- rendering from templates -->
<div class="panel-content" [innerHtml]="html | sanitizeHtml"></div>
<!-- rendering from templates end -->
<div id="view-1" style="display: inherit" *ngIf="show">
  <div>
    <input
      id="print_title"
      class="panel-text-box"
      maxlength="100"
      placeholder="Enter map title here"
      type="text"
      [(ngModel)]="title"
      (keyup.enter)="createFile()"
    />
  </div>
  <input
    type="checkbox"
    id="data_panel_hide"
    [(ngModel)]="hide"
    (change)="onSelect($event)"
  /><span class="panel-text-box">Hide Data Panel</span><br />
  <div class="button-containerTop">
    <a
      id="print-link"
      title="Compiles your current map view into a printable format."
      class="btn btn-default pull-right"
      (click)="createFile()"
      >Print</a
    >
    <div style="clear: both"></div>
  </div>
</div>

<div id="view-2" style="display: block" *ngIf="!show">
  <p class="panel-text">
    Downloads the file. When complete, click to view in a new tab.
  </p>
  <div class="button-container">
    <a
    id="download-map"
    type="button"
    class="btn btn-primary pull-right"
    title="Opens new tab. View, download, or print PDF"
    href="{{this.DownloadFileName}}"
    target="_blank"
    style="display: inline-block"
      (click)="view()"
      >View</a
    >
    <div style="clear: both"></div>
  </div>
</div>
<div class="buttonDiv">
  <a class="closer  closerToolTip" >
    <img
    (click)="closeLeft()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span
      class="tooltiptext tip-bottom"
      [innerHtml]="mapService.templatetoolTips['close_left_panel']"
    ></span>
  </a>
</div>
<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <img style="width: 100px;" src="/assets/img/wheel.svg" alt="Girl in a jacket" width="100px" height="100px" >
  </ngx-spinner>